module.exports = __webpack_public_path__ + "img/05.82df215b.jpg";